<template>
  <div>
    <AutocompleteFacet v-model="filter.meeting" :label="$t('meetingFacetLabel')" :items="facets.meeting" />
    <DateRangeFilterField :label="$t('dateFieldFilter.label')" :max.sync="beginDateMax" :min.sync="beginDateMin" />
    <AutocompleteFacet
      v-model="filter.business_type"
      :label="$t('businessTypeFacetLabel')"
      :items="facets.business_type"
    />
  </div>
</template>

<script>
import dateTimeFilterMixin from '@/components/search/mixins/datetimefilter'

export default {
  name: 'AgendaItemFacets',
  mixins: [dateTimeFilterMixin],
  props: {
    facets: {
      type: Object,
      default: () => ({}),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
